module.exports = "https://cdn.realtymogul.com/static/media/RP_safeway.aa5d064c.jpg";